import { stepById } from "../coach.mjs";

const $ = (id) => document.getElementById(id);

export function bindUi(handlers) {
  $("btn-move").onclick = () => handlers.setMode("move");
  $("btn-face").onclick = () => handlers.setMode("face");
  $("btn-group").onclick = () => handlers.groupMove();
  $("btn-wheel").onclick = () => handlers.wheel();
  $("btn-attack").onclick = () => handlers.setMode("attack");
  $("btn-end").onclick = () => handlers.endTurn();
  $("btn-commit").onclick = () => handlers.commitMove();
  $("btn-new").onclick = () => handlers.openPicker();
  $("btn-map").onclick = () => handlers.toggleMinimap();
  for (const btn of document.querySelectorAll("#build-tabs [data-tab]")) btn.onclick = () => handlers.setBuildTab(btn.dataset.tab);
  $("picker-cancel").onclick = () => hidePicker();
  $("seed-random").onclick = () => { $("seed-input").value = String(1 + Math.floor(Math.random() * 99999)); };
  $("map-picker").addEventListener("click", (e) => {
    const btn = e.target.closest("[data-map]");
    if (!btn || !$("map-picker").contains(btn)) return;
    const extras = [...$("picker-effects").querySelectorAll("input:checked")].map((el) => el.value);
    handlers.newMatch({ map: btn.dataset.map, seed: Math.max(1, Number($("seed-input").value) || 1), effects: extras });
  });
  $("btn-recenter").onclick = () => handlers.recenter();
  $("victory-again").onclick = () => handlers.newMatch();
  $("dir-cancel").onclick = () => { hideDir(); handlers.cancelOverlay?.(); };
  $("wheel-cancel").onclick = () => { hideWheel(); handlers.cancelOverlay?.(); };
  $("wheel-cw").onclick = () => handlers.confirmWheel("cw");
  $("wheel-ccw").onclick = () => handlers.confirmWheel("ccw");
  $("coach-skip").onclick = () => handlers.skipCoach();
  $("coach-help").onclick = () => handlers.tutorial("open");
  $("tut-next").onclick = () => handlers.tutorial("next");
  $("tut-back").onclick = () => handlers.tutorial("back");
  $("tut-skip").onclick = () => handlers.tutorial("skip");
  $("btn-key").onclick = () => toggleLegend();
  for (const btn of document.querySelectorAll("#dir-pad [data-dir]")) {
    btn.onclick = () => handlers.pickDir(Number(btn.dataset.dir));
  }
}

export function setModeName(mode, extra = "") {
  $("mode-name").textContent = (mode || "select") + extra;
  for (const id of ["btn-move", "btn-face", "btn-attack"]) {
    $(id).classList.toggle("active", mode === id.replace("btn-", ""));
  }
}

export function renderStatus(html) { $("status").innerHTML = html; }
export function renderInspect(html) { $("inspect").innerHTML = html; }
export function renderProduce(html) { $("produce").innerHTML = html; }
export function renderReserves(html) { $("reserve-cards").innerHTML = html; }
export function renderEconomy(html) { $("economy").innerHTML = html; }
export function setBuildTab(tab) {
  for (const btn of document.querySelectorAll("#build-tabs [data-tab]")) btn.classList.toggle("active", btn.dataset.tab === tab);
}

export function showPicker(choice, maps, effectsTable = {}) {
  const cards = $("map-cards");
  cards.innerHTML = Object.entries(maps).map(([id, m]) => {
    const fx = (m.effects ?? []).map((e) => effectsTable[e]?.name ?? e).join(" · ");
    return `<button type="button" class="map-card ${id === choice.map ? "active" : ""}" data-map="${id}">
      <b>${m.label}</b><small>${m.detail}${fx ? ` · ${fx}` : ""}</small>
    </button>`;
  }).join("");
  const defaults = new Set(maps[choice.map]?.effects ?? []);
  $("picker-effects").innerHTML = Object.values(effectsTable).map((e) => {
    const on = defaults.has(e.id) || (choice.effects ?? []).includes(e.id);
    const locked = defaults.has(e.id);
    return `<label class="fx-toggle ${locked ? "locked" : ""}">
      <input type="checkbox" value="${e.id}" ${on ? "checked" : ""} ${locked ? "disabled" : ""} />
      <span><b>${e.name}</b> ${e.description}</span>
    </label>`;
  }).join("");
  $("seed-input").value = String(choice.seed ?? 1);
  $("map-picker").hidden = false;
}
export function hidePicker() { $("map-picker").hidden = true; }
export function pickerOpen() { return !$("map-picker").hidden; }

/** Minimap and its toggle only exist on large boards; open by default on wide screens. */
export function setMinimap(large, open) {
  $("btn-map").hidden = !large;
  $("minimap").hidden = !(large && open);
  $("btn-map").classList.toggle("active", !$("minimap").hidden);
}
export function toggleMinimap() {
  $("minimap").hidden = !$("minimap").hidden;
  $("btn-map").classList.toggle("active", !$("minimap").hidden);
}

export function toggleLegend(open) {
  const el = $("legend");
  el.hidden = open === undefined ? !el.hidden : !open;
  $("btn-key").classList.toggle("active", !el.hidden);
}

export function renderTutorial(page, index, total) {
  const box = $("tutorial");
  if (!page) {
    box.hidden = true;
    return;
  }
  $("tut-title").textContent = page.title;
  $("tut-body").textContent = page.body;
  $("tut-legend").hidden = !page.legend;
  $("tut-count").textContent = `${index + 1} / ${total}`;
  $("tut-back").disabled = index === 0;
  $("tut-next").textContent = index + 1 === total ? "Play" : "Next";
  box.hidden = false;
  $("tut-next").focus({ preventScroll: true });
}

export function log(msg) {
  const el = $("log");
  const t = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  el.insertAdjacentHTML("afterbegin", `<div>[${t}] ${msg}</div>`);
}

export function showDir(title) {
  $("dir-title").textContent = title;
  $("dir-pad").hidden = false;
}
export function hideDir() { $("dir-pad").hidden = true; }
export function dirOpen() { return !$("dir-pad").hidden; }

export function showWheel(ids, onPick) {
  const box = $("wheel-pivots");
  box.innerHTML = ids.map((id) => `<button type="button" data-pivot="${id}">${id}</button>`).join("");
  for (const btn of box.querySelectorAll("button")) btn.onclick = () => onPick(btn.dataset.pivot);
  $("wheel-pad").hidden = false;
}
export function hideWheel() { $("wheel-pad").hidden = true; }
export function wheelOpen() { return !$("wheel-pad").hidden; }

export function showVictory(title, body) {
  $("victory-title").textContent = title;
  $("victory-body").textContent = body;
  $("victory").hidden = false;
}
export function hideVictory() { $("victory").hidden = true; }

export function renderCoach(stepId) {
  const bar = $("coach");
  const step = stepById(stepId);
  if (!step) {
    bar.hidden = true;
    return;
  }
  $("coach-title").textContent = step.title;
  $("coach-text").textContent = step.text;
  $("coach-dots").innerHTML = ["select", "move", "attack", "end"].map((id) =>
    `<span class="${id === stepId ? "on" : ""}"></span>`).join("");
  bar.hidden = false;
}

export function setBusy(busy) {
  for (const id of ["btn-move", "btn-face", "btn-group", "btn-wheel", "btn-attack", "btn-end", "btn-commit"]) {
    $(id).disabled = busy;
  }
}
